module.exports = __webpack_public_path__ + "static/media/cov_cov_ppe.9cc92055.png";